import SocketService from "network/SocketService";
import { QuizAction } from "./QuizReducer";
import {
  QuizProtocol,
  QuizMode,
  SetModeData,
  StartRoundData,
  OXSubmitData,
  AnswerSubmitData,
  ContinueRoundData,
  ModeChangedData,
  PhaseReadyData,
  RoundStartedData,
  PlayerRespondedData,
  ResultsRevealedData,
} from "./QuizProtocol";

export class QuizSocketService {
  private dispatch: React.Dispatch<QuizAction>;
  private socket = SocketService.getInstance();

  constructor(dispatch: React.Dispatch<QuizAction>) {
    this.dispatch = dispatch;
  }

  public initializeListeners() {
    // Mode changed
    this.socket.on(QuizProtocol.MODE_CHANGED, (data: ModeChangedData) => {
      console.log("MODE CHANGEd", data);
      this.dispatch({ type: "SET_MODE", payload: data.mode });
    });

    // Game ready state
    this.socket.on(QuizProtocol.PHASE_READY, (data: PhaseReadyData) => {
      this.dispatch({
        type: "UPDATE_GAME_STATE",
        payload: {
          mode: data.mode,
          players: data.players,
          roundState: data.roundState,
          question: data.currentQuestion,
          responses: data.responses,
        },
      });
    });

    // Round started
    this.socket.on(QuizProtocol.ROUND_STARTED, (data: RoundStartedData) => {
      this.dispatch({
        type: "ROUND_STARTED",
        payload: {
          question: data.question,
          mode: data.mode,
        },
      });
    });

    // Round stopped
    this.socket.on(QuizProtocol.ROUND_STOPPED, () => {
      this.dispatch({ type: "ROUND_STOPPED" });
    });

    // Round continued
    this.socket.on(QuizProtocol.ROUND_CONTINUED, (data: RoundStartedData) => {
      this.dispatch({
        type: "ROUND_CONTINUED",
        payload: {
          question: data.question,
          mode: data.mode,
        },
      });
    });

    // Player responded (real-time)
    this.socket.on(
      QuizProtocol.PLAYER_RESPONDED,
      (data: PlayerRespondedData) => {
        this.dispatch({
          type: "PLAYER_RESPONDED",
          payload: {
            playerId: data.playerId,
            playerName: data.playerName,
            order: data.order,
            mode: data.mode,
          },
        });
      }
    );

    // Results revealed
    this.socket.on(
      QuizProtocol.RESULTS_REVEALED,
      (data: ResultsRevealedData) => {
        this.dispatch({
          type: "RESULTS_REVEALED",
          payload: {
            mode: data.mode,
            question: data.question,
            totalPlayers: data.totalPlayers,
            responded: data.responded,
            responses: data.responses,
            oCount: data.oCount,
            xCount: data.xCount,
          },
        });
      }
    );
  }

  public removeListeners() {
    this.socket.off(QuizProtocol.MODE_CHANGED);
    this.socket.off(QuizProtocol.PHASE_READY);
    this.socket.off(QuizProtocol.ROUND_STARTED);
    this.socket.off(QuizProtocol.ROUND_STOPPED);
    this.socket.off(QuizProtocol.ROUND_CONTINUED);
    this.socket.off(QuizProtocol.PLAYER_RESPONDED);
    this.socket.off(QuizProtocol.RESULTS_REVEALED);
  }

  // Host Controls
  public setMode(mode: QuizMode) {
    const data: SetModeData = { mode };
    this.socket.emit(QuizProtocol.SET_MODE, data);
  }

  public startRound(question: string) {
    const data: StartRoundData = { question };
    this.socket.emit(QuizProtocol.START_ROUND, data);
  }

  public stopRound() {
    this.socket.emit(QuizProtocol.STOP_ROUND);
  }

  public resetRound() {
    this.socket.emit(QuizProtocol.RESET_ROUND);
  }

  public continueRound(question?: string) {
    const data: ContinueRoundData = question ? { question } : {};
    this.socket.emit(QuizProtocol.CONTINUE_ROUND, data);
  }

  public revealResponses() {
    this.socket.emit(QuizProtocol.REVEAL_RESPONSES);
  }

  // Player Actions
  public pressBuzzer() {
    this.dispatch({ type: "SET_HAS_SUBMITTED", payload: true });
    this.socket.emit(QuizProtocol.BUZZER_PRESS);
  }

  public submitOX(choice: "O" | "X") {
    this.dispatch({ type: "SET_HAS_SUBMITTED", payload: true });
    const data: OXSubmitData = { choice };
    this.socket.emit(QuizProtocol.OX_SUBMIT, data);
  }

  public submitAnswer(answer: string) {
    this.dispatch({ type: "SET_HAS_SUBMITTED", payload: true });
    const data: AnswerSubmitData = { answer };
    this.socket.emit(QuizProtocol.ANSWER_SUBMIT, data);
  }
}
